import axios from 'axios';
import config from '../config';
import { store } from '../store';

const getHeaders = () => {
  const { authToken } = store.getState().user;
  return { authorization: authToken };
};

/**
 * Insurer-scoped endpoint map. Adding a third insurer = add one block here +
 * the analogous block in services/agentRoster.js. No other frontend changes.
 */
const ENDPOINTS_BY_INSURER = {
  max: {
    misV2:        '/max-users/acefone/dial-mis/v2',
    manualRedial: '/max-users/acefone/manual-redial',
  },
  starhealth: {
    misV2:        '/starhealth/auto-dial/dial-mis/v2',
    manualRedial: '/starhealth/auto-dial/manual-redial',
  },
  icicilbd: {
    misV2:        '/icicilbd/auto-dial/dial-mis/v2',
    manualRedial: '/icicilbd/auto-dial/manual-redial',
  },
  abhi: {
    misV2:        '/abhi/auto-dial/dial-mis/v2',
    manualRedial: '/abhi/auto-dial/manual-redial',
  },
};

const endpointsFor = (insurer) => {
  const e = ENDPOINTS_BY_INSURER[insurer];
  if (!e) {
    throw new Error(`[autoDialOps service] Unsupported insurer: ${insurer}`);
  }
  return e;
};

export const getMisV2 = (insurer, agentType = 'doctor') => {
  const e = endpointsFor(insurer);
  return axios
    .get(`${config.apiBaseUrl}${e.misV2}`, {
      params:  { agent_type: agentType },
      headers: getHeaders(),
    })
    .then((r) => r.data);
};

export const manualRedial = (insurer, applicationNos, agentType = 'doctor') => {
  const e = endpointsFor(insurer);
  return axios
    .post(
      `${config.apiBaseUrl}${e.manualRedial}`,
      { application_nos: applicationNos, agent_type: agentType },
      { headers: getHeaders() }
    )
    .then((r) => r.data);
};
